import { APIComponentType } from '@ardoq/api-types';
import { ArdoqIconCategory, IconSize } from '@ardoq/icons';
import {
  EntityIcon,
  getComponentRepresentationDataWithColorShades,
} from '@ardoq/basic-components';

export type ComponentTypeEntityIconProps = {
  componentType: APIComponentType;
};

export const ComponentTypeEntityIcon = ({
  componentType,
}: ComponentTypeEntityIconProps) => {
  const representationData = getComponentRepresentationDataWithColorShades({
    level: componentType.level ?? 0,
    icon: componentType.icon ?? null,
    image: componentType.image ?? null,
    color: componentType.color ?? null,
  });

  return (
    <EntityIcon
      imageSrc={
        representationData.isImage ? representationData.value : undefined
      }
      iconId={
        representationData.icon.category === ArdoqIconCategory.FontAwesome ||
        ('isSVG' in representationData.icon && representationData.icon.isSVG)
          ? representationData.icon.id
          : undefined
      }
      iconSize={IconSize.MEDIUM}
      color={representationData.color}
    />
  );
};
